// Backlog #332: every translation namespace, per language. Add a namespace here in BOTH languages
// (src/locales/tr/<ns>.json and src/locales/en/<ns>.json) and list it in `namespaces`.
//
// Keys are semantic (camelCase Turkish words, grouped per page: "projeler.baslik"). Turkish is the
// fallback language, so a key missing from en shows the Turkish text -- but keep both files complete.
import trCommon from "./tr/common.json";
import enCommon from "./en/common.json";
import trHeader from "./tr/header.json";
import enHeader from "./en/header.json";
import trMenu from "./tr/menu.json";
import enMenu from "./en/menu.json";
import trPortal from "./tr/portal.json";
import enPortal from "./en/portal.json";
import trTadilat from "./tr/tadilat.json";
import enTadilat from "./en/tadilat.json";
// Shared components the portal renders (also used on staff pages), one section per component.
import trComponents from "./tr/components.json";
import enComponents from "./en/components.json";
// Labels and messages the services produce (status maps, errors), one section per service.
import trServices from "./tr/services.json";
import enServices from "./en/services.json";

// Staff pages (#349), one namespace per area of src/pages/Management, one section per page: Projects (incl. Fuar Kuralları, Global Kurallar).
import trProjeler from "./tr/projeler.json";
import enProjeler from "./en/projeler.json";
// Management/Modules (Firmalar, Standlar, Personel, Kişiler ...).
import trModuller from "./tr/moduller.json";
import enModuller from "./en/moduller.json";
// Management/SistemAyarlari (Sistem Ayarları pages, incl. Çeviriler, #337).
import trAyarlar from "./tr/ayarlar.json";
import enAyarlar from "./en/ayarlar.json";
// Management/Forms, Management/FreeForm and the form builder components.
import trFormlar from "./tr/formlar.json";
import enFormlar from "./en/formlar.json";
// The field app: pages/Saha, pages/FdsSaha, Components/Saha.
import trSaha from "./tr/saha.json";
import enSaha from "./en/saha.json";
// The other Management pages (Fuarlar, Fuar Alanları, Salonlar, Kroki, Kişi, Kullanıcılar, Tadilat, Sürdürülebilirlik).
import trYonetim from "./tr/yonetim.json";
import enYonetim from "./en/yonetim.json";
// Login and the pages around it.
import trGiris from "./tr/giris.json";
import enGiris from "./en/giris.json";
// SMS: Sistem Ayarları > SMS pages, announcements and panel invitations (backlog #637, #643, #647).
import trSms from "./tr/sms.json";
import enSms from "./en/sms.json";
// The temporary person panel, a public mobile page opened from an SMS link (backlog #646).
import trKisiPanel from "./tr/kisiPanel.json";
import enKisiPanel from "./en/kisiPanel.json";
// Text inside generated PDFs (it follows the language the PDF is made in, not the UI language) and the buttons that make them (backlog #541).
import trPdf from "./tr/pdf.json";
import enPdf from "./en/pdf.json";

// The printed entrance card (backlog #745): its texts follow the UI language, the print dialog's notes beside the button.
import trKart from "./tr/kart.json";
import enKart from "./en/kart.json";

// Deleting an uploaded company document (backlog #736): the confirm window shared by Firma Kartı and the staff company-document review.
import trBelgeSil from "./tr/belgeSil.json";
import enBelgeSil from "./en/belgeSil.json";

export const namespaces = ["common", "header", "menu", "portal", "tadilat", "components", "services", "projeler", "moduller", "ayarlar", "formlar", "saha", "yonetim", "giris", "sms", "kisiPanel", "pdf", "kart", "belgeSil"];

export const resources = {
  tr: { common: trCommon, header: trHeader, menu: trMenu, portal: trPortal, tadilat: trTadilat, components: trComponents, services: trServices, projeler: trProjeler, moduller: trModuller, ayarlar: trAyarlar, formlar: trFormlar, saha: trSaha, yonetim: trYonetim, giris: trGiris, sms: trSms, kisiPanel: trKisiPanel, pdf: trPdf, kart: trKart, belgeSil: trBelgeSil },
  en: { common: enCommon, header: enHeader, menu: enMenu, portal: enPortal, tadilat: enTadilat, components: enComponents, services: enServices, projeler: enProjeler, moduller: enModuller, ayarlar: enAyarlar, formlar: enFormlar, saha: enSaha, yonetim: enYonetim, giris: enGiris, sms: enSms, kisiPanel: enKisiPanel, pdf: enPdf, kart: enKart, belgeSil: enBelgeSil },
};
